var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{staticClass:"payout-banner__tabs",attrs:{"type":"is-toggle"},on:{"input":_vm.updateSelectedEra}},_vm._l((_vm.availableEras),function(era,index){return _c('b-tab-item',{key:index,attrs:{"label":era.text}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }